// Shared design tokens for the modern card surfaces (Data Manager, Results,
// Results Summary). These are intentionally separate from the legacy argon
// palette in `colors.js`: the accent here is a brand purple (#6B35DE) with a
// cyan secondary (#06B6D4), used for borders, gradients, tints and text.
//
// Values are the union of the previously-duplicated token sets in
// ResultSummaryDashboard (`COLORS`) and CollapsibleCard (`CARD_COLORS`); shared
// keys were byte-for-byte identical between them.
const CARD_TOKENS = {
  primary: "#6B35DE",
  primaryLight: "#C4B5FD",
  primaryExtraLight: "#EDE9FE",
  accent: "#06B6D4",
  accentLight: "#A5F3FC",
  accentExtraLight: "#ECFEFF",
  success: "#10B981",
  successLight: "#D1FAE5",
  warning: "#F59E0B",
  warningLight: "#FEF3C7",
  bg: "#F9F7FF",
  cardBg: "#FFFFFF",
  contentBg: "#fcfcfc",
  border: "rgba(107, 53, 222, 0.12)",
  text: "#1E1B4B",
  textMuted: "#6B7280",
  // Soft purple tint used for card drop-shadows and count chips.
  shadow: "rgba(107, 53, 222, 0.08)",
  chipBg: "rgba(107, 53, 222, 0.08)",
  headerGradient:
    "linear-gradient(135deg, rgba(107,53,222,0.03) 0%, rgba(6,182,212,0.03) 100%)",
};

export default CARD_TOKENS;
export { CARD_TOKENS };
